import { useNavigate } from 'react-router-dom';
import Button from './Button';
import { Box, Typography } from '@mui/material';

const PageHeader = ({ title, showBackButton = false, backUrl = '/', onBack }) => {
    const navigate = useNavigate();

    const handleBack = () => {
        if (onBack) onBack();
        else navigate(-1);
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '5px',
            }}
        >
            <Typography className="fw-bold text-gray-700 text-uppercase" variant="h5">
                {title}
            </Typography>
            {showBackButton && <Button text="Voltar" onClick={handleBack} />}
        </Box>
    );
};

export default PageHeader;
